import * as mutationType from "../mutation_types";

const state = {
  teams: [],
  edit_team: {},
  team_users: [],
  team_subteams: [],
  activities: []
};

const getters = {
  teams: state => state.teams,
  edit_team: state => state.edit_team,
  team_users: state => state.team_users,
  team_subteams: state => state.team_subteams,
  activities: state => state.activities
};

const actions = {
  getTeams({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/teams")
        .then(res => {
          commit(mutationType.SET_TEAMS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getTeam({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/teams/" + id)
        .then(res => {
          commit(mutationType.SET_EDIT_TEAM, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  addTeam({ commit }, team) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/teams", team)
        .then(res => {
          team.id = res.data;
          commit(mutationType.SET_TEAM, team);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  updateTeam({ commit }, team) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put("/api/teams/" + team.id, team)
        .then(res => {
          team.id = res.data;
          commit(mutationType.SET_EDIT_TEAM, team);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteTeam({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete("/api/teams/" + id)
        .then(() => {
          commit(mutationType.DELETE_TEAM, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  uploadLogo({ commit }, file) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append("file", file.file);
      this._vm.$http
        .post(`/api/teams/${file.id}/logo`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          commit(mutationType.SET_TEAM_LOGO, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getTeamUsers({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/teams/" + id + "/users")
        .then(res => {
          commit(mutationType.SET_TEAM_USERS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getTeamSubTeams({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/teams/" + id + "/subTeams")
        .then(res => {
          commit(mutationType.SET_TEAM_SUBTEAMS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  addTeamUsers({ state }, teamUsers) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/teams/" + state.edit_team.id + "/users", teamUsers)
        .then(() => {
          //commit(mutationType.SET_TEAM_USER, teamUser);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  updateTeamUser({ state, commit }, teamUser) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          "/api/teams/" + state.edit_team.id + "/users/" + teamUser.id,
          teamUser
        )
        .then(() => {
          commit(mutationType.SET_TEAM_USER, teamUser);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteTeamUser({ state, commit }, teamUser) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete("/api/teams/" + state.edit_team.id + "/users/" + teamUser.id)
        .then(() => {
          commit(mutationType.DELETE_TEAM_USER, teamUser.id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getActivities({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/teams/" + id + "/activities")
        .then(res => {
          commit(mutationType.SET_TEAM_ACTIVITIES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_TEAMS](state, list) {
    state.teams = list;
  },
  [mutationType.SET_EDIT_TEAM](state, team) {
    state.edit_team = team;
    state.activities = [];
  },
  [mutationType.SET_TEAM](state, team) {
    state.edit_team = Object.assign(state.edit_team, team);
  },
  [mutationType.SET_TEAM_LOGO](state, url) {
    if (state.edit_team) {
      state.edit_team.logoUrl = url;
    }
  },
  [mutationType.DELETE_TEAM](state, id) {
    let index = state.teams.findIndex(cv => cv.id == id);
    if (index >= 0) {
      state.teams.splice(index, 1);
    }
  },
  [mutationType.SET_TEAM_USERS](state, list) {
    state.team_users = list;
  },
  [mutationType.SET_TEAM_USER](state, teamUser) {
    let index = state.team_users.findIndex(cv => cv.id == teamUser.id);
    if (index >= 0) {
      state.team_users[index] = Object.assign(
        state.team_users[index],
        teamUser
      );
    }
  },
  [mutationType.DELETE_TEAM_USER](state, id) {
    let index = state.team_users.findIndex(cv => cv.id == id);
    if (index >= 0) {
      state.team_users.splice(index, 1);
    }
  },
  [mutationType.SET_TEAM_SUBTEAMS](state, list) {
    state.team_subteams = list;
  },
  [mutationType.SET_TEAM_ACTIVITIES](state, list) {
    state.activities = list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
